export const PANOS_SCAN_COMMAND = `cnspec scan panos --hostname <PANOS_DEVICE_IP> --username <USERNAME> --ask-pass`;
